module.exports = "/_next/static/images/Ryan signature-7be605884695d09c53ac534c75808c5b.png";